module.exports = eval("try{require('cluster')}catch(e){}");